// extracted by mini-css-extract-plugin
module.exports = {"text":"CompanyButton_text__3mAvC","button":"CompanyButton_button__3YvXT"};